var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Button, Col, Divider, Form, Input, Row } from "antd";
import React from "react";
import { FormFieldConfigs, LabelConfigs } from "../../configurations";
import { AmplitudeEventsUtils, DataUtils } from "../../utilities";
var ChangePasswordForm = /** @class */ (function (_super) {
    __extends(ChangePasswordForm, _super);
    function ChangePasswordForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            updatingUser: false,
            confirmDirtyPassword: false,
            confirmDirtyEmail: false
        };
        _this.compareToFirstPassword = function (rule, value, callback) {
            var form = _this.props.form;
            if (value && value !== form.getFieldValue(FormFieldConfigs.PASSWORD.key)) {
                callback(LabelConfigs.INCONSISTENT_PASSWORD);
            }
            else {
                callback();
            }
        };
        _this.validateToNextPassword = function (rule, value, callback) {
            var form = _this.props.form;
            if (value && _this.state.confirmDirtyPassword) {
                form.validateFields([FormFieldConfigs.CONFIRM_PASSWORD.key], { force: true });
            }
            callback();
        };
        _this.onSubmit = function (e) {
            var _a = _this.props, onUpdate = _a.onUpdate, authentication = _a.authentication, user = _a.user;
            e.preventDefault();
            e.stopPropagation();
            _this.props.form.validateFields(function (err, values) {
                console.debug('Received values of createUserForm: ', values, err);
                if (!err) {
                    _this.setState({ updatingUser: true });
                    DataUtils.user(authentication).update(user.id, values)
                        .then(function (user) { return onUpdate(user); })
                        .finally(function () { return _this.setState({ updatingUser: false }); });
                    AmplitudeEventsUtils.userListUpdateUser('password');
                }
            });
        };
        _this.onCancel = function (e) {
            var onCancel = _this.props.onCancel;
            var resetFields = _this.props.form.resetFields;
            resetFields();
            onCancel();
        };
        _this.render = function () {
            var updatingUser = _this.state.updatingUser;
            var getFieldDecorator = _this.props.form.getFieldDecorator;
            return (React.createElement(Form, { style: { height: "100%" }, onReset: _this.onCancel, layout: "vertical", className: "bold-label", onSubmit: _this.onSubmit },
                React.createElement(Row, { gutter: 64, className: "no-margin", style: { overflowX: "scroll", height: "calc(100% - 68px)" } },
                    React.createElement(Col, { span: 24, className: "margin-bottom-lg padding-left-md padding-right-md" },
                        React.createElement("p", { className: "login-form-info color-gray-6 margin-top-lg", style: { fontSize: "12px", marginBottom: "16px" } }, "Password must be at least 8 characters and include at least one:"),
                        React.createElement("div", { className: "color-gray-5 margin-bottom-xs", style: { display: "flex", flexDirection: "column", fontSize: "12px" } },
                            React.createElement("div", { style: { display: "flex", flexDirection: "row" } },
                                React.createElement("div", { style: { flex: "1 1 0px" } }, "- Lowercase letter"),
                                React.createElement("div", { style: { flex: "1 1 0px" } }, "- Uppercase letter")),
                            React.createElement("div", { style: { display: "flex", flexDirection: "row" } },
                                React.createElement("div", { style: { flex: "1 1 0px" } }, "- Numeric digit"),
                                React.createElement("div", { style: { flex: "1 1 0px" } },
                                    "- Special character ",
                                    React.createElement("br", null),
                                    " ! @ # $ % ^ & + = ( ) *"))),
                        React.createElement("br", null),
                        React.createElement(Form.Item, { label: FormFieldConfigs.PASSWORD.label }, getFieldDecorator(FormFieldConfigs.PASSWORD.key, {
                            rules: __spreadArray(__spreadArray([], FormFieldConfigs.PASSWORD.rules(true), true), [
                                {
                                    validator: _this.validateToNextPassword,
                                }
                            ], false)
                        })(React.createElement(Input.Password, { placeholder: FormFieldConfigs.PASSWORD.placeholder }))),
                        React.createElement(Form.Item, { label: FormFieldConfigs.CONFIRM_PASSWORD.label }, getFieldDecorator(FormFieldConfigs.CONFIRM_PASSWORD.key, {
                            rules: __spreadArray(__spreadArray([], FormFieldConfigs.CONFIRM_PASSWORD.rules(true), true), [
                                {
                                    validator: _this.compareToFirstPassword,
                                }
                            ], false)
                        })(React.createElement(Input.Password, { placeholder: FormFieldConfigs.CONFIRM_PASSWORD.placeholder }))))),
                React.createElement("div", null,
                    React.createElement(Divider, { className: "no-margin", style: { boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.16)' } }),
                    React.createElement("div", { className: "align-right padding-md" },
                        React.createElement(Button, { type: "link", htmlType: "reset", disabled: updatingUser }, LabelConfigs.CANCEL),
                        React.createElement("span", { className: "margin-right-sm" }),
                        React.createElement(Button, { type: "primary", htmlType: "submit", loading: updatingUser, disabled: updatingUser }, "Save")))));
        };
        return _this;
    }
    return ChangePasswordForm;
}(React.Component));
export default Form.create({ name: 'changePassword' })(ChangePasswordForm);
//# sourceMappingURL=change-password-form.js.map